module.exports = __webpack_public_path__ + "img/23.a99ee74a.jpg";